export const gffConfigActionTypes = {
  UPDATE_GFF_CONFIG: 'UPDATE_GFF_CONFIG'
};
